import { CalcElement, CalcResult, parseCalcResult, valuesFromParams } from "./calc-result";
import { opsMissionTypeEnum, parameterStruct } from "./dataStruct";

export type CalcStep = "fuel" | "loading" | "perf";

export interface LiveCalc {
  rowId: string;
  signatureId: string;
  result: CalcResult | null;
  values: Record<string, string>;
  elements: CalcElement[] | null;
  inputs: Record<string, number>;
}

export type ParamReader = (
  parameterHash: string,
  tableSuffix: string,
  opsMissionType: opsMissionTypeEnum
) => Promise<Pick<parameterStruct, "parameter" | "value">[]>;

export async function liveCalc(
  classCom: { namedQuery(name: string, params: Record<string, unknown>): Promise<any[]> },
  step: CalcStep,
  flightId: string,
  opsMissionType: opsMissionTypeEnum,
  readParams: ParamReader
): Promise<LiveCalc | null> {
  const rows = await classCom.namedQuery(step + "ResultByFlight", { flightId, opsMissionType });
  const row = rows[0];
  if (!row) return null;
  const signatureId = row.signatureId ?? "";

  if (typeof row.resultJson === "string" && row.resultJson !== "") {
    const result = parseCalcResult(row.resultJson);
    if (!result) return null;
    return {
      rowId: row.rowId,
      signatureId,
      result,
      values: result.values,
      elements: result.elements ?? null,
      inputs: result.inputs,
    };
  }

  let hash = flightId;
  if (step === "fuel") {
    const hashRows = await classCom.namedQuery("fuelHashAndMassByFlight", { flightId, opsMissionType });
    if (!hashRows[0]) return null;
    hash = hashRows[0].parameterHash;
  }

  let paramRows = await readParams(hash, step, opsMissionType);
  if (step === "perf") {
    const all = await readParams(hash, step, opsMissionTypeEnum.all);
    paramRows = [...all, ...paramRows];
  }
  return {
    rowId: row.rowId,
    signatureId,
    result: null,
    values: valuesFromParams(paramRows),
    elements: null,
    inputs: {},
  };
}
